import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { environment } from '../../../environments/environment';
import { MapsBaseService } from '@shared/services/maps-base.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService extends MapsBaseService {
  private mapLoader: Loader;
  private mapsLibrary: google.maps.MapsLibrary = null;
  private markerLibrary: google.maps.MarkerLibrary = null;
  private placesLibrary: google.maps.PlacesLibrary = null;

  constructor() {
    super();
    this.mapLoader = new Loader({
      apiKey: environment.googleMapsApiKey,
      version: 'weekly',
      libraries: ['maps', 'marker', 'places'],
    });
  }

  getMapsLibrary(): Promise<google.maps.MapsLibrary> {
    const that = this;
    return new Promise<google.maps.MapsLibrary>((resolve) => {
      if (that.mapsLibrary == null) {
        that.mapLoader.importLibrary('maps').then((mapsLibrary) => {
          that.mapsLibrary = mapsLibrary;
          resolve(mapsLibrary);
        });
      } else {
        resolve(that.mapsLibrary);
      }
    });
  }

  getPlacesLibrary(): Promise<google.maps.PlacesLibrary> {
    const that = this;
    return new Promise<google.maps.PlacesLibrary>((resolve) => {
      if (that.placesLibrary == null) {
        that.mapLoader.importLibrary('places').then((placesLibrary) => {
          that.placesLibrary = placesLibrary;
          resolve(placesLibrary);
        });
      } else {
        resolve(that.placesLibrary);
      }
    });
  }

  getMarkerLibrary(): Promise<google.maps.MarkerLibrary> {
    const that = this;
    return new Promise<google.maps.MarkerLibrary>((resolve) => {
      if (that.markerLibrary == null) {
        that.mapLoader.importLibrary('marker').then((markerLibrary) => {
          that.markerLibrary = markerLibrary;
          resolve(markerLibrary);
        });
      } else {
        resolve(that.markerLibrary);
      }
    });
  }

  loadMap(selector: string, mapOptions: google.maps.MapOptions): Promise<google.maps.Map> {
    return new Promise((resolve) => {
      this.getMapsLibrary().then(({ Map }) => {
        resolve(new Map(document.getElementById(selector), mapOptions));
      });
    });
  }
}
